import React from 'react';

import { renderSongTexts, Song } from './songbeamer';
import { SongDB, SongWFile } from './songdb';

function useWindowSize() {
	const [size, setSize] = React.useState({
		width: window.innerWidth,
		height: window.innerHeight,
	});
	React.useEffect(() => {
		const handleResize = () => {
			setSize({
				width: window.innerWidth,
				height: window.innerHeight,
			});
		};
		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);
	return size;
}

function Loading() {
	return <div style={{ textAlign: 'center', marginTop: '20%' }}>
		<h1>Loading...</h1>
		<p>Generating Search Index, this can take a while...</p>
	</div>;
}

function SideBarSongElement({ song, onClick, sel }: { song: SongWFile, onClick: () => void, sel: boolean }) {
	let title = '';
	if(song.props.Title && song.props.Title.length > 0){
		title = song.props.Title[0];
		if(song.props.Songbook){
			title = `${song.props.Songbook} - ${title}`;
		}
	}else{
		title = song.file;
	}
	return <div style={{ padding: 5, backgroundColor: sel ? '#ccc' : 'transparent' }} onClick={onClick}>
		<span>{title}</span>
	</div>;
}

function SideBar({songs: {songs, index}, onSel, sel}: { songs: SongDB, onSel?: (sel: string) => void, sel: string|null }) {
	const [search, setSearch] = React.useState('');
	let songList: SongWFile[] = [];
	if(search && search.length > 0){
		const found = index.search(search, {
			limit: 100,
			suggest: true
		});
		songList = Array.from(new Set(found.map(id => id.toString().split('$')[0]))).map(file => songs.get(file)!);
	}else{
		songList = Array.from(songs.values()).sort((a, b) => a.file.localeCompare(b.file));
	}
	return <div style={{overflow: 'hidden', height: '100%'}}>
		<div>
			<input type="text" placeholder="Search..." value={search} onChange={e => setSearch(e.target.value)} style={{ width: '100%', boxSizing: 'border-box', padding: '8px', marginBottom: '10px' }} />
		</div>
		<hr />
		<div style={{ overflowY: 'auto', height: 'calc(100% - 60px)' }}>
			{songList.map(song => <SideBarSongElement sel={sel === song.file} onClick={() => onSel?.(song.file)} key={song.file} song={song} />)}
		</div>
	</div>
}

function SongDisplay({ song, file }: { file: string, song: Song | undefined | null }) {
	if(!song) return <div>Select a song...</div>;
	const ccli = song.props.CCLI && song.props.CCLI !== '-' ? song.props.CCLI : null;
	const props = {...song.props};
	delete props.CCLI;
	delete props.ChurchSongID;
	delete props.VerseOrder;
	delete props.Songbook;
	delete props.Editor;
	delete props.Version;
	delete props.LangCount;
	return <div style={{ overflowY: 'auto', height: '100%' }} >
		<h1>
			{song.props.Title?.[0] || file}
			{song.props.Songbook ? ' ('+song.props.Songbook+')' : null}
		</h1>
		<div style={{ border: '1px solid #ccc', padding: '10px', marginBottom: '10px' }}>
			{ccli ? <div>
				CCLI: <a target='_blank' rel="noreferrer" href={`https://songselect.ccli.com/songs/${ccli}`}>{ccli}</a>
			</div> : null}
			{Object.entries(props).map(([key, value]) => <div key={key}>{key}: {value.toString()}</div>)}
		</div>
		<div dangerouslySetInnerHTML={{ __html: renderSongTexts(song) }} />
	</div>;
}

function App({songDb}: {songDb?: SongDB}) {
	const [sel, setSel] = React.useState<string|null>(null);
	const windowSize = useWindowSize();
	const isMobile = windowSize.width <= 650;
	const [showSidebar, setShowSidebar] = React.useState(!isMobile);
	const selSong = sel ? songDb?.songs.get(sel)! : null;
	const MainContent = !songDb ? <Loading /> : <SongDisplay file={sel ?? ''} song={selSong} />;
	const sideBar = songDb ? <SideBar songs={songDb} onSel={s => {
		setSel(s);
		setShowSidebar(false);
	}} sel={sel} /> : <></>;
	if(isMobile){
		return <div>
			<div style={{ display: 'fixed', height: 60, width: '100%', backgroundColor: '#282c34'}}>
				<button onClick={() => setShowSidebar(st=>!st)} style={{ margin: '16px' }}>
					{showSidebar ? 'X' : 'Menu'}
				</button>
			</div>
			<div style={{ display: 'flex', flexDirection: 'row', height: '100vh' }}>
				<div style={{display: showSidebar ? 'block' : 'none'}}>
					{sideBar}
				</div>
				<div style={{ display: showSidebar ? 'none' : 'block' }}>
					{MainContent}
				</div>
			</div>
		</div>;
	}else{
		return <div>
			<div style={{ display: 'flex', flexDirection: 'row', height: '100vh' }}>
				<div style={{ flex: 2, minWidth: '300px', padding: '16px', backgroundColor: '#f0f0f0' }}>
					{sideBar}
				</div>
				<div style={{ flex: 8, padding: '16px' }}>
					{MainContent}
				</div>
			</div>
		</div>
	}
}

export default App;
